import React from 'react';
import StartPageContainer from '../app/components/StartPage/StartPageContainer';

const Index = () => {
    return <StartPageContainer></StartPageContainer>;
};

export default Index;
